import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IConfirmUserPayload {
    email: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const confirmUserSlice = createSlice({
    name: 'hub/user/confirm-user',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IConfirmUserPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const confirmUserActions = confirmUserSlice.actions
export default confirmUserSlice.reducer
